import React, { FC } from "react";
import classNames from "classnames";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { AnimationState } from "@app/hooks/use-slider/enums";
import { useIsXLMediaQuery } from "@app/hooks";
import { Slide } from "../../../../types";

type Props = {
  data: Slide[];
  activeSlide: number;
  animationState: AnimationState;
  onSlideSelect: (index: number) => void;
  onPause?: () => void;
  onStartPlay?: () => void;
};

export const Navigation: FC<Props> = ({
  data,
  activeSlide,
  animationState,
  onSlideSelect,
  onPause,
  onStartPlay,
}) => {
  const isLargeScreen = useIsXLMediaQuery();

  return (
    <div
      className={classNames(
        "flex cursor-pointer gap-x-2.5 text-medium text-base-400",
        "lg:gap-x-6",
        "xl:flex-col xl:text-large",
      )}
    >
      {data.map((slideData, index) => (
        <div
          key={slideData._uid}
          className={classNames(
            "h-1 w-full overflow-hidden rounded-full bg-divider",
            "lg:h-1.5",
            "xl:relative xl:h-auto xl:rounded-none xl:bg-transparent",
            "xl:border-b xl:border-divider xl:py-4 xl:first:border-t",
            "hover:text-primary-content",
          )}
          onClick={() => onSlideSelect(index)}
          onMouseEnter={() => index === activeSlide && onPause()}
          onMouseLeave={() => index === activeSlide && onStartPlay()}
        >
          {isLargeScreen ? (
            <>
              <BlockHeader
                richText={slideData.title}
                className={classNames("duration-700", {
                  "text-primary-content": index === activeSlide,
                })}
              />
              {index === activeSlide ? (
                <div
                  className={classNames(
                    "absolute bottom-0 h-px w-full origin-left",
                    {
                      "animate-fill-width bg-primary-content":
                        animationState !== AnimationState.STOPED,
                      pause: animationState === AnimationState.PAUSED,
                    },
                  )}
                />
              ) : null}
            </>
          ) : (
            <div>
              {index === activeSlide ? (
                <div
                  className={classNames(
                    "h-1 w-full origin-left rounded-full",
                    "lg:h-1.5",
                    {
                      "animate-fill-width bg-primary-content":
                        animationState !== AnimationState.STOPED,
                    },
                  )}
                />
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
